import axios from "axios";

function getSig() {
  let url = `https://yc.novaecs.com/php/get_water.php`;
  return axios.get(url);
}

async function ossUpload(uid, files) {
  var dir = "water-pic";
  var filename = new Date().getTime() + "_" + uid + ".jpg";
  var signatureInfoObj = await getSig().then(x => x.data);
  let oss_url = signatureInfoObj.host.replace(/^(https?:)/, location.protocol);
  var data = {
    Filename: filename,
    key: signatureInfoObj["dir"] + dir + "/" + filename, //可以填写文件夹名（对应于oss服务中的文件夹）/
    policy: signatureInfoObj["policy"],
    OSSAccessKeyId: signatureInfoObj["accessid"],
    success_action_status: "200", //让服务端返回200，不然，默认会返回204
    signature: signatureInfoObj["signature"],
    file: files
  };
  var formData = new FormData();
  for (var k in data) {
    formData.append(k, data[k]);
  }
  return axios.post(oss_url, formData).then(res => {
    return filename;
  });
}

async function ossUploadPdf(filename, files) {
  var dir = "water-file";
  var signatureInfoObj = await getSig().then(x => x.data);
  let oss_url = signatureInfoObj.host.replace(/^(https?:)/, location.protocol);
  var data = {
    Filename: filename,
    key: signatureInfoObj["dir"] + dir + "/" + filename, //可以填写文件夹名（对应于oss服务中的文件夹）/
    policy: signatureInfoObj["policy"],
    OSSAccessKeyId: signatureInfoObj["accessid"],
    success_action_status: "200", //让服务端返回200，不然，默认会返回204
    signature: signatureInfoObj["signature"],
    file: files
  };
  var formData = new FormData();
  for (var k in data) {
    formData.append(k, data[k]);
  }
  return axios.post(oss_url, formData).then(res => {
    return filename;
  });
}

export { ossUpload, ossUploadPdf };
